import { render, staticRenderFns } from "./account-email.vue?vue&type=template&id=742f736e&"
import script from "./account-email.vue?vue&type=script&lang=js&"
export * from "./account-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports